module.exports = __webpack_public_path__ + "img/call-center.858e9d35.svg";